import { Injectable } from '@angular/core'
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { I18N_DATEPICKER_VALUES } from '../../shared/constants/consts'
import { AppLanguageService } from './app-language.service'

@Injectable()
export class CustomNgbDatepickerI18n extends NgbDatepickerI18n {
    constructor(private appLanguageService: AppLanguageService) {
        super()
    }

    getWeekdayLabel(weekday: number): string {
        return I18N_DATEPICKER_VALUES[this.lang].weekdays[weekday - 1]
    }

    getMonthShortName(month: number): string {
        return I18N_DATEPICKER_VALUES[this.lang].months[month - 1]
    }

    getMonthFullName(month: number): string {
        return this.getMonthShortName(month)
    }

    getDayAriaLabel(date: NgbDateStruct): string {
        return `${date.day}-${date.month}-${date.year}`
    }

    get lang(): string {
        return this.appLanguageService.getAppLanguage()
    }
}
